module.exports = __webpack_public_path__ + "static/media/cardAnimation.410af71e.gif";